<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Detalles del empleo</h3>
                    <p class="font-gray-dark">Ingresa la información correspondiente para continuar</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">

                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>

                        <div class="target-body pb-5" v-show="!downloading">
                            <b-form @submit="onSubmit">
                                <b-form-group label="Título del empleo" id="title">
                                    <b-form-input
                                            ref="title"
                                            v-model="form.title" type="text" required
                                            placeholder="Ej. Diseñador Gráfico" autocomplete="off">
                                    </b-form-input>
                                    <b-form-invalid-feedback :state="false" v-if="errors.title">
                                        {{ errors.title[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <div class="d-flex flex-wrap justify-content-between">
                                    <b-form-group label="Ubicación del empleo" class="col-lg-6 p-1">

                                       <vue-google-autocomplete
                                            id="map"
                                            classname="form-control"
                                            rows="6"
                                            placeholder="¿Dónde se encuentra la vacante?"
                                            v-on:placechanged="getAddressData"
                                            :country="['mx']"
                                        >
                                        </vue-google-autocomplete>    
                                        <!-- <places
                                                :class="'form-control'"
                                                v-model="form.location"
                                                placeholder="¿Dónde se encuentra la vacante?"
                                                @change="val => { country.data = val }"
                                                :options="{ countries: [] }">
                                        </places> -->
                                    </b-form-group>

                                    <b-form-group label="Área de trabajo" class="col-lg-6 p-1">
                                        <b-form-select v-model="workarea_select" class="mb-2">
                                            <option :value="''">Selecciona una opción</option>
                                            <option :value="item" v-for="(item, key) in workareas" :key="key">
                                                {{ item }}
                                            </option>
                                            <optgroup label="Otra opción">
                                                <option value="otro">Escribe otra opción</option>
                                            </optgroup>
                                        </b-form-select>
                                        <b-form-input v-model="form.workarea" type="text" required
                                                      placeholder="Ej. Encargado de área"
                                                      v-if="workarea_select == 'otro'"></b-form-input>
                                        <b-form-invalid-feedback :state="false" v-if="errors.workarea">
                                            El campo área de trabajo es requerido.
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group label="Jornada Laboral" class="col-lg-4 p-1">
                                        <b-form-select
                                                v-model="form.jornada_laboral"
                                                :options="jornada_laboral"
                                                required>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="false" v-if="errors.jornada_laboral">
                                            {{ errors.jornada_laboral[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group label="Horario Laboral" class="col-lg-4 p-1">
                                        <b-form-select
                                                v-model="form.horario_laboral"
                                                :options="horario_laboral"
                                                required>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="false" v-if="errors.horario_laboral">
                                            {{ errors.horario_laboral[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group label="Tipo de Empleo" class="col-lg-4 p-1">
                                        <b-form-select
                                                v-model="form.tipo_empleo"
                                                :options="tipos_empleo"
                                                required>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="false" v-if="errors.tipo_empleo">
                                            {{ errors.tipo_empleo[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group class="w-100">
                                        <b-form-checkbox v-model="mostrar_salario" name="check-button" switch>Mostrar
                                            salario
                                        </b-form-checkbox>
                                    </b-form-group>

                                    <b-form-group label="Salario Mínimo" class="col-lg-4 p-1" v-if="mostrar_salario">
                                        <vue-numeric class="form-control" currency="$" separator=","
                                                     v-bind:precision="2" v-model="form.salario_min"></vue-numeric>

                                        <b-form-invalid-feedback :state="false" v-if="errors.salario_min">
                                            {{ errors.salario_min[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group label="Salario Máximo" class="col-lg-4 p-1" v-if="mostrar_salario">
                                        <vue-numeric class="form-control" currency="$" separator=","
                                                     v-bind:precision="2" v-model="form.salario_max"></vue-numeric>

                                        <b-form-invalid-feedback :state="false" v-if="errors.salario_max">
                                            {{ errors.salario_max[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group label="Periodo" class="col-lg-4 p-1" v-if="mostrar_salario">
                                        <b-form-select
                                                v-model="form.periodo"
                                                :options="periodos"
                                                required>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="false" v-if="errors.periodo">
                                            {{ errors.periodo[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>

                                <div class="row justify-content-center">
                                 <div class="col-md-4 col-12"> 
                                    <b-form-group label="Prestaciones" class="mb-5">
                                        <b-form-checkbox v-model="form.prestaciones.despensa" name="check-button" switch>
                                            Vales de despensa
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.gasolina" name="check-button" switch>
                                            Vales de gasolina
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.vacaciones" name="check-button" switch>
                                            Prestaciones Superiores
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.acciones" name="check-button" switch>
                                            Acciones
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.prestaciones" name="check-button" switch>
                                            Prestaciones de Ley
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.flex_horario" name="check-button" switch>
                                            Flexibilidad de Horario
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.comedor" name="check-button" switch>
                                            Comedor
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.fondo_ahorro" name="check-button" switch>
                                            Fondo de ahorro
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.caja_ahorro" name="check-button" switch>
                                             Caja de ahorro
                                        </b-form-checkbox>
                                        <template v-if="isMobile">
                                           <b-form-checkbox v-model="form.prestaciones.ayuda_transporte" name="check-button" switch>
                                                Ayuda de transporte
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.becas_escolar" name="check-button" switch>
                                                Becas o apoyo escolar
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.bono_asistencia" name="check-button" switch>
                                                Bono de asistencia
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.bono_productividad" name="check-button" switch>
                                                Bono de productividad
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.bono_puntualidad" name="check-button" switch >
                                            Bono de puntualidad
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.medico_mayor" name="check-button" switch>
                                                Gastos médicos mayores
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.medico_menor" name="check-button" switch>
                                                Gastos médicos menores
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.guarderia" name="check-button" switch>
                                                Guardería
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="form.prestaciones.comision" name="check-button" switch>
                                                Comisiones
                                            </b-form-checkbox>
                                        </template>
                                    </b-form-group>
                                 </div>
                                 <div class="col-md-4 col-12" v-if="!isMobile"> 
                                    <br>
                                    <b-form-group  class="mb-5">
                                        <b-form-checkbox v-model="form.prestaciones.ayuda_transporte" name="check-button" switch>
                                            Ayuda de transporte
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.becas_escolar" name="check-button" switch>
                                            Becas o apoyo escolar
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.bono_asistencia" name="check-button" switch>
                                            Bono de asistencia
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.bono_productividad" name="check-button" switch>
                                            Bono de productividad
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.bono_puntualidad" name="check-button" switch >
                                           Bono de puntualidad
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.medico_mayor" name="check-button" switch>
                                            Gastos médicos mayores
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.medico_menor" name="check-button" switch>
                                            Gastos médicos menores
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.guarderia" name="check-button" switch>
                                            Guardería
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="form.prestaciones.comision" name="check-button" switch>
                                            Comisiones
                                        </b-form-checkbox>
                                    </b-form-group>
                                 </div>
                                </div>

                                <b-form-group class="w-100">
                                    <label>
                                        <i class="fa fa-magic" aria-hidden="true"></i> Habilidades
                                         <u style="color:#ed8f00; cursor: pointer;" class="ml-2" @click="otra_hab ? otra_hab = false : otra_hab = true">
                                            <template v-if="otra_hab">Ocultar</template><template v-else>Agregar</template> nueva opción
                                        </u>
                                    </label>
                                    <b-input-group prepend="Nueva habilidad" class="mt-3" v-if="otra_hab">
                                        <b-form-input v-model="nueva_hab"></b-form-input>
                                        <b-input-group-append> 
                                        <b-button variant="info" @click="guardaHab()">Guardar</b-button>
                                        </b-input-group-append> 
                                    </b-input-group>
                                    <small class="text-danger" v-if="error_hab == 1">Campo requerido</small>
                                    <v-select :id="isMobile ? 'Camn' : ''" style="color: #000;" 
                                    class="mt-2" multiple v-model="form.cv_skills" :options="skills" :reduce="skills => skills.name" :get-option-label="getOptionLabel"/>
                                    <b-form-invalid-feedback :state="false" v-if="errors.cv_skills">
                                        El campo habilidades es requerido.
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group class="w-100">
                                    <label>
                                        <i class="fa fa-desktop" aria-hidden="true"></i> Software
                                        <u style="color:#ed8f00; cursor: pointer;" class="ml-2" @click="otra_soft ? otra_soft = false : otra_soft = true">
                                            <template v-if="otra_soft">Ocultar</template><template v-else>Agregar</template> nueva opción
                                        </u>
                                    </label>
                                    <b-input-group prepend="Nuevo software" class="mt-3" v-if="otra_soft">
                                        <b-form-input v-model="nueva_sof"></b-form-input>
                                        <b-input-group-append> 
                                        <b-button variant="info" @click="guardaSoft()">Guardar</b-button>
                                        </b-input-group-append>                                        
                                    </b-input-group>
                                    <small class="text-danger" v-if="error_sof == 1">Campo requerido</small>
                                    <v-select style="color: #000;" 
                                    class="mt-2" multiple v-model="form.cv_softwares" :options="softwares" :reduce="softwares => softwares.name" :get-option-label="getOptionLabel"/>
                                    <b-form-invalid-feedback :state="false" v-if="errors.cv_skills">
                                        El campo software es requerido.
                                    </b-form-invalid-feedback>
                                </b-form-group>


                                <b-form-group label="Descripción">
                                    <vue-editor v-model="form.description" :editorToolbar="customToolbar"></vue-editor>
                                    <b-form-invalid-feedback :state="false" v-if="errors.description">
                                        {{ errors.description[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group label="Requerimientos">
                                    <vue-editor v-model="form.requeriment" :editorToolbar="customToolbar"></vue-editor>
                                </b-form-group>

                                <b-alert show variant="danger" v-show="validation.message">{{ validation.message }}
                                </b-alert>

                                <center>
                                    <b-button type="button" class="font-white shadow bg-danger mt-2" @click="$router.push('/perfil/empleos')"> 
                                        Cancelar
                                    </b-button>  
                                    <br v-if="isMobile"> 
                                    <b-button type="button" :class="isMobile ? 'font-white shadow bg-primary mt-3'  : 'font-white shadow bg-primary ml-3'" @click="previewValid">
                                        <i class="fas fa-eye"></i>
                                        Previsualizar
                                    </b-button> 
                                    <br v-if="isMobile"> 
                                    <b-button type="submit" :class="isMobile ? 'b-orange shadow mt-3' : 'b-orange shadow ml-3'" :disabled="loading.insert"
                                            v-show="!remove">
                                        <b-spinner v-if="loading.insert" small label="Espere ..."></b-spinner>
                                        {{ this.id ? 'Aplicar Cambios' : 'Iniciar Publicación' }}
                                    </b-button>
                                </center>
                            </b-form>
                        </div>

                        <!---Preview-->
                        <b-modal hide-header hide-footer body-class="p-0" v-model="preview" size="lg">
                            <div>
                                <div class="header b-blue p-5">
                                    <h5>{{ form.title }} <br>
                                        <i class="fas fa-globe"></i> <span> {{ form.workarea }}</span>
                                    </h5>

                                    <div class="enterprise-data mt-3">
                                        <vue-letter-avatar :name='enterpriseName' size='30' :rounded=true>
                                        </vue-letter-avatar>
                                        <label class="font-weight-light ml-1">{{ enterpriseName }}</label>
                                        <b-button class="b-orange float-right" @click="onSubmit"><i
                                                class="fas fa-paper-plane"></i> Publicar
                                        </b-button>
                                        <b-button class="b-blue float-right" @click="preview = false"><i
                                                class="fas fa-pen"></i> Editar
                                        </b-button>
                                    </div>
                                </div>
                                <div class="b-gray-light p-3">
                                    <i class="fas fa-share-alt"></i> Esta información se vera reflejada al momento de
                                    publicar tu vacante.
                                </div>
                                <div class="row py-5 px-3 text-justify">
                                    <div class="col-lg-7">
                                        <h5 class="font-weight-light">Descripción</h5>
                                        <p v-html="form.description"></p>

                                        <h5 class="font-weight-light">Requisitos</h5>
                                        <p v-html="form.requeriment"></p>
                                    </div>
                                    <div class="col-lg-5">
                                        <h5 class="font-weight-light">Ubicación</h5>
                                        <p>{{ form.location }}</p>

                                        <h5 class="font-weight-light" v-show="mostrar_salario">Rango Salarial</h5>
                                        <p v-show="mostrar_salario"><span class="font-gray-dark"></span>
                                            {{ form.salario_min | currency }} a <span class="font-gray-dark"></span>
                                            {{ form.salario_max | currency }} {{ form.periodo }}</p>

                                        <h5 class="font-weight-light" v-show="showPrestaciones">Prestaciones</h5>
                                        <ul class="d-flex flex-wrap p-0" v-show="showPrestaciones">
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.acciones"><i class="fas fa-comment-dollar"></i>
                                                Acciones
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.comedor"><i class="fas fa-utensils"></i> Comedor
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.despensa"><i class="fas fa-shopping-bag"></i>
                                                Despensa
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.flex_horario"><i class="fas fa-clock"></i>
                                                Flexibilidad de horario
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.gasolina"><i class="fas fa-gas-pump"></i>
                                                Gasolina
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.prestaciones"><i class="fas fa-certificate"></i>
                                                Prestaciones
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light"
                                                v-if="form.prestaciones.vacaciones"><i
                                                    class="fas fa-umbrella-beach"></i> Vacaciones
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.ayuda_transporte"><i
                                                class="fas fa-bus"></i> Ayuda de transporte
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.becas_escolar"><i
                                                class="fas fa-graduation-cap"></i>  Becas o apoyo escolar
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.bono_asistencia"><i
                                                class="fas fa-calendar-week"></i>  Bono de asistencia
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.bono_productividad"><i
                                                class="fas fa-business-time"></i> Bono de productividad
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.medico_mayor"><i
                                                class="fas fa-briefcase-medical"></i>  Gastos médicos mayores
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.bono_puntualidad"><i
                                                class="fas fa-user-clock"></i>  Bono de puntualidad
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.caja_ahorro"><i
                                                class="fas fa-wallet"></i> Caja de ahorro
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.comision"><i
                                                class="fas fa-coins"></i> Comisiones
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.fondo_ahorro"><i
                                                class="fas fa-dollar-sign"></i> Fondo de ahorro
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.guarderia"><i
                                                class="fas fa-child"></i> Guardería
                                            </li>
                                            <li class="my-1 list-inline-item p-2 rounded b-gray-light" v-if="form.prestaciones.medico_menor"><i
                                                class="fas fa-briefcase-medical"></i> Gastos médicos menores
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </b-modal>
                        <!---./Preview-->



                        <b-card class="mt-3" header="Form Data Result" v-if="this.$appDebug">
                            <pre class="m-0">{{ $data }}</pre>
                        </b-card>

                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>
<script>
import {VueEditor} from "vue2-editor"
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
    props: {
        parentCurse: Object
    },
    components: {
        VueEditor,
        VueGoogleAutocomplete
    },
    data() {
        return {
            isMobile: this.$mobile(), 
            customToolbar: [
                ["bold", "italic"],
                [{list: "ordered"}],
                [{list: "bullet"}],
                ["image", false]
            ],
            mostrar_salario: true,
            preview: false,
            id: null,
            downloading: false,
            remove: false,
            country: {},
            periodos: [{text: 'Selecciona una opción', value: null}, 'Mensual', 'Quincenal', 'Semanal', 'Por Hora'],
            workareas: [],
            skills: [],
            softwares: [],
            workarea_select: '',
            jornada_laboral: [{
                text: 'Selecciona una opción',
                value: null
            }, 'Indeterminado', 'Temporal', 'Becario/Prácticas'],
            horario_laboral: [{
                text: 'Selecciona una opción',
                value: null
            }, 'Tiempo Completo', 'Medio Tiempo'],
            tipos_empleo: [{
                text: 'Selecciona una opción',
                value: null
            }, 'Presencial', 'Home Office','Híbrido'],
            previewCover: null,
            loading: {
                insert: false,
                delete: false,
            },
            form: {
                title: null,
                location: null,
                description: null,
                requeriment: null,
                workarea: null,
                cv_skills: [],
                cv_softwares: [],
                category_other: null,
                tipo_empleo: null,
                horario_laboral: null,
                jornada_laboral:null,
                periodo: null,
                salario_max: 0,
                salario_min: 0,
                prestaciones: {
                    despensa: false,
                    gasolina: false,
                    vacaciones: false,
                    acciones: false,
                    prestaciones: false,
                    flex_horario: false,
                    comedor: false, 
                    ayuda_transporte:false,
                    becas_escolar:false,
                    bono_asistencia:false,
                    bono_productividad:false,
                    bono_puntualidad:false,
                    caja_ahorro:false,
                    comision:false,
                    fondo_ahorro:false,
                    guarderia:false,
                    medico_menor:false,
                    medico_mayor:false
                },
            },
            errors: {},
            validation: {},
            otra_hab:false,
            otra_soft:false,
            nueva_hab:"",
            nueva_sof:"",
            error_hab:0,
            error_sof:0,
            direccion:"",
            address:"", 
        }
    },
    computed: {
        enterpriseName: function () {
            return this.$store.getters.userName
        },
        showPrestaciones: function () {
            for (const [key, value] of Object.entries(this.form.prestaciones)) {
                if (value) {
                    return true
                }
            }
        },
    },
    watch: {
        workarea_select: function (val) {
            if (val) {
                if (val == 'otro') {
                    this.form.workarea = ''
                } else {
                    this.form.workarea = val
                }
            }
        }
    },
    methods: {
         getAddressData: function (addressData, placeResultData) {
            this.address = addressData;
            this.form.location = placeResultData.formatted_address; 
        },
        previewValid() {
            if (this.form.title && this.form.location && this.form.description && this.form.workarea) {
                this.preview = true
            } else {
                swal('Vista previa no disponible', 'Es importante llenar los datos del formulario para poder tener una vista previa', 'warning')
            }
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.errors = {}
            this.preview = false
            if (this.id) {
                this.update()
            } else {
                this.insert()
            }
        },
        update() {
            this.loading.insert = true
            this.api.put('enterprise/job/update/' + this.id, JSON.stringify(this.form)).then(({data}) => {
                this.toast("Se ha actualizado correctamente tu empleo", true)
                this.loading.insert = false
                 setTimeout(() => {
                     this.$router.push('/perfil/empleos')
                   }, 300)
            }).catch(err => {
                this.loading.insert = false
                // if (err.response.status == 403) {
                    this.errors =  err.response.data.errors
                    this.$refs.title.focus()
                    this.toast('', false)
                // }else{
                // // } else if (err.response.status == 404) {
                //     this.validation = err.response.data.errors
                //     this.toast('', false)
                // }
            })
        },
        insert() {
            this.loading.insert = true
            //console.log( JSON.stringify(this.form) )
            this.api.post('enterprise/job/create', JSON.stringify(this.form)).then(({data}) => {
                this.loading.insert = false
                this.toast("Se ha registrado correctamente tu empleo", true)
                setTimeout(() => {
                     this.$router.push('/perfil/empleos')
                   }, 300)
            }).catch(err => {
                this.loading.insert = false
                console.log(err)
                // if (err.response.status == 403) {
                    this.errors = err.response.data.errors
                    this.toast('', false)
                    this.$refs.title.focus()
                // } else{
                //     this.validation = err.response.data.errors
                //     this.toast('', false)
                // }
            })
        },
        guardaHab(){
            this.error_hab = 0
         if (!this.nueva_hab ) {
            this.error_hab = 1
         }
         if (this.error_hab == 0) { 
            this.api.post('enterprise/job/new_hab',{ 'nueva_hab': this.nueva_hab}).then(({data}) => {
                console.log(data) 
                this.form.cv_skills.push(this.nueva_hab)
                this.toast("Se ha registrado correctamente la habilidad", true) 
                this.nueva_hab = ""
                this.loadSkills() 
            }).catch(err => { 
               console.log(err) 
               this.toast('', false) 
            })
         }
        },
        guardaSoft(){
            this.error_sof = 0
         if (!this.nueva_sof ) {
            this.error_sof = 1
         }
         if (this.error_sof == 0) { 
            this.api.post('enterprise/job/new_soft',{ 'nueva_sof': this.nueva_sof}).then(({data}) => {
                    console.log(data) 
                    this.form.cv_softwares.push(this.nueva_sof)
                    this.toast("Se ha registrado correctamente el software", true)  
                    this.nueva_sof = ""
                    this.loadSoftwares()
                }).catch(err => { 
                console.log(err) 
                this.toast('', false) 
                })
         }
        },
        toast(message, success) {
            if (success) {

                this.$bvToast.toast(message, {
                    title: "Kllaar.com",
                    variant: 'success',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })

            } else {
                this.$bvToast.toast('Es importante llenar todos los campos del formulario', {
                    title: "Kllaar.com",
                    variant: 'danger',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })
            }
        },
        loadWorkAreas() {
            this.api.get('module/work_area').then(({data}) => {
                this.workareas = data.data
            }).catch(err => {
            })
        },
        loadSkills() {
            this.api.get('module/skillID').then(({data}) => {
                this.skills = data.data;
            }).catch(err => {
            })
        },
        getOptionLabel(option) {
            return (option && option.name) || ''
        },
        loadSoftwares() {
            this.api.get('module/softwareID').then(({data}) => {
                this.softwares = data.data
            }).catch(err => {
            })
        }
    },
    created() {
        let id = this.$route.params.id
        this.showPrestaciones

        if (id !== undefined) {
            this.id = id
            this.downloading = true
            this.api.get('enterprise/job/find/' + id).then(({data}) => {
                this.form.title = data.data.titulo
                this.form.description = data.data.descripcion
                this.form.location = data.data.ubicacion
                this.form.requeriment = data.data.requisitos
                this.form.workarea = data.data.workarea_id
                this.workarea_select = data.data.workarea
                this.form.cv_skills = data.data.cv_skills.split("|")
                this.form.cv_softwares = data.data.cv_softwares.split("|")
                this.form.category_other = data.data.category_other
                this.form.jornada_laboral = data.data.jornada_laboral
                this.form.horario_laboral = data.data.horario_laboral
                this.form.tipo_empleo = data.data.tipo_empleo
                this.form.periodo = data.data.periodo
                this.form.salario_max = data.data.salario_max
                this.form.salario_min = data.data.salario_min
                if (data.data.prestaciones) {
                    this.form.prestaciones = data.data.prestaciones
                }
                this.error_hab = 0;
                this.downloading = false
            }).catch(err => {
                this.downloading = false
                console.log(err)
            })
        }

        this.loadWorkAreas()
        this.loadSkills()
        this.loadSoftwares()
    },
}
</script>
<style>

#mySelect .v-select .dropdown-toggle {
   border: none;
}

.text-orange {
    color: #ed8f00 !important;
}

.active-orange-4 input[type=text]:focus:not([readonly]) {
    border: 1px solid #ee9800;
    box-shadow: 0 0 0 1px #ee9800;
}

.vs__selected {
    background-color: #ee9800;
    color: white !important;
    border: none !important;
}

.vs__selected svg {
    fill: white !important;
}

.spinner > div {
    background: #ee9800 !important;
    width: 120px !important;
    height: 120px !important;

}

</style>
<style lang="scss"> 


.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }
    .data {
      .is-empty, .is-loading {
        padding: 45px;
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/Name.vue